$(document).ready(function() {
    $('.js-example-basic-single').select2();
});